import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { PublicCalendar } from './pages/PublicCalendar';
import { Login } from './pages/Login';
import { StayForm } from './pages/StayForm';
import { ExternalLogin } from './pages/ExternalLogin';
import { ExternalStayForm } from './pages/ExternalStayForm';
import { Confirmation } from './pages/Confirmation';
import { Impressum } from './pages/Impressum';
import { Datenschutz } from './pages/Datenschutz';
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminCalendarTab } from './pages/admin/AdminCalendarTab';
import { AdminHutDutyTab } from './pages/admin/AdminHutDutyTab';
import { AdminBookingsTab } from './pages/admin/AdminBookingsTab';
import { AdminExportTab } from './pages/admin/AdminExportTab';
import { AdminSettingsTab } from './pages/admin/AdminSettingsTab';
import { AdminDienstplanungTab } from './pages/admin/AdminDienstplanungTab';
import { PollPage } from './pages/PollPage';
import { AuthProvider } from './auth/AuthContext';
import { RequireGuest } from './auth/RequireGuest';
import { RequireAdmin } from './auth/RequireAdmin';
import { RequireExternal } from './auth/RequireExternal';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<PublicCalendar />} />
            <Route path="anmelden" element={<Login />} />
            <Route path="impressum" element={<Impressum />} />
            <Route path="datenschutz" element={<Datenschutz />} />
            <Route
              path="abrechnung"
              element={
                <RequireGuest>
                  <StayForm />
                </RequireGuest>
              }
            />
            <Route
              path="abrechnung/bestaetigung"
              element={
                <RequireGuest>
                  <Confirmation />
                </RequireGuest>
              }
            />
            <Route path="dienst/:token" element={<PollPage />} />
            <Route path="gast" element={<ExternalLogin />} />
            <Route
              path="gast-abrechnung"
              element={
                <RequireExternal>
                  <ExternalStayForm />
                </RequireExternal>
              }
            />
            <Route
              path="gast-abrechnung/bestaetigung"
              element={
                <RequireExternal>
                  <Confirmation />
                </RequireExternal>
              }
            />
            <Route path="admin" element={<AdminLogin />} />
            <Route
              path="admin/dashboard"
              element={
                <RequireAdmin>
                  <AdminDashboard />
                </RequireAdmin>
              }
            >
              <Route index element={<Navigate to="kalender" replace />} />
              <Route path="kalender" element={<AdminCalendarTab />} />
              <Route path="hutteneinsatz" element={<AdminHutDutyTab />} />
              <Route path="dienstplanung" element={<AdminDienstplanungTab />} />
              <Route path="buchungen" element={<AdminBookingsTab />} />
              <Route path="export" element={<AdminExportTab />} />
              <Route path="einstellungen" element={<AdminSettingsTab />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
